export class LetterHeadValueObject {
  constructor(
    public readonly owner: string,
    public readonly department: string,
    public readonly province: string,
    public readonly district: string,
    public readonly mapName: string,
    public readonly source: string,
    public readonly author: string,
  ) {}
}
